import { render } from "./selectChannelShop.vue?vue&type=template&id=3c774003&scoped=true"
import script from "./selectChannelShop.vue?vue&type=script&lang=js"
export * from "./selectChannelShop.vue?vue&type=script&lang=js"

import "./selectChannelShop.vue?vue&type=style&index=0&id=3c774003&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c774003"]])

export default __exports__